module.exports = __webpack_public_path__ + "img/1929.dce5fa96.svg";